var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import ButtonLink from '@kiwicom/orbit-components/lib/ButtonLink';
import styled, { css } from 'styled-components';
export var CustomButtonLink = styled(ButtonLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    background-color: #e0e0e0;\n  }\n"], ["\n  &:hover {\n    background-color: #e0e0e0;\n  }\n"])));
export var SidebarButtonLink = styled(ButtonLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 40px;\n  border-radius: 0;\n\n  ", "\n  &:hover {\n    background-color: #363636 !important;\n  }\n"], ["\n  height: 40px;\n  border-radius: 0;\n\n  ", "\n  &:hover {\n    background-color: #363636 !important;\n  }\n"])), function (props) {
    return props.selected
        ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          background-color: rgba(53, 53, 53, 1) !important;\n        "], ["\n          background-color: rgba(53, 53, 53, 1) !important;\n        "]))) : css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          background-color: rgba(37, 37, 37, 1) !important;\n        "], ["\n          background-color: rgba(37, 37, 37, 1) !important;\n        "])));
});
var StyledButtonLink = /** @class */ (function (_super) {
    __extends(StyledButtonLink, _super);
    function StyledButtonLink(props) {
        var _this = _super.call(this, props) || this;
        _this.customOnClick = function (event) {
            _this.props.onClick();
            event.stopPropagation();
        };
        _this.state = {};
        return _this;
    }
    StyledButtonLink.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, selected = _a.selected, viewBuilder = _a.viewBuilder, props = __rest(_a, ["onClick", "selected", "viewBuilder"]);
        return (_jsx(_Fragment, { children: viewBuilder ? (_jsx(SidebarButtonLink, __assign({ selected: selected, onClick: this.customOnClick }, props, { children: this.props.children }))) : (_jsx(CustomButtonLink, __assign({}, props, { onClick: this.customOnClick }, { children: this.props.children }))) }));
    };
    return StyledButtonLink;
}(React.Component));
export default StyledButtonLink;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
